import React from 'react';

const QuoteCard = ({ text, author }) => {
  return (
    <div style={styles.container}>
      {/* Decorative Quote Mark */}
      <div style={styles.quoteSymbol}>“</div>
      
      {/* Quote Text */}
      <p style={styles.text}>
        {text}
      </p>
      
      {/* Author Section */}
      <div style={styles.authorContainer}>
        <span style={styles.line}></span>
        <p style={styles.author}>{author}</p>
      </div>
    </div>
  );
};

// Styling Object
const styles = {
  container: {
    backgroundColor: '#ffffff',
    borderLeft: '8px solid  #034d28', // The stylish Green accent
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
    padding: '30px',
    maxWidth: '600px',
    margin: '20px auto',
    position: 'relative',
    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    transition: 'transform 0.2s ease',
  },
  quoteSymbol: {
    position: 'absolute',
    top: '-10px',
    left: '20px',
    fontSize: '80px',
    color: '#e8f8f5', // Very pale green for subtle background effect
    fontFamily: 'Georgia, serif',
    zIndex: 0,
    lineHeight: 1,
  },
  text: {
    position: 'relative',
    zIndex: 1,
    fontSize: '1.25rem',
    lineHeight: '1.6',
    color: '#2c3e50', // Dark grey for readability against white
    fontStyle: 'italic',
    margin: '0 0 20px 0',
  },
  authorContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '15px',
  },
  line: {
    height: '2px',
    width: '30px',
    backgroundColor: ' #034d28', // Matching Green
    marginRight: '10px',
  },
  author: {
    color: ' #034d28', // A slightly darker green for text contrast
    fontWeight: 'bold',
    fontSize: '1rem',
    letterSpacing: '1px',
    margin: 0,
    textTransform: 'uppercase',
  }
};

export default QuoteCard;